export const DXG_DMS_EXPORT_STATE_BAGGAGE_NAME = 'deal360.dmsExportState';
